import useSWR from "swr";

export const INSIGHTS_HISTORY_URL =
  "https://insights.cryptember.com/insights/history?key=XbNjQPPkT9wSllpWr1";

const fetchHistory = async (url) => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`History request failed with ${response.status}`);
  }
  return response.json();
};

export default function useInsightsHistory(enabled = true) {
  return useSWR(enabled ? INSIGHTS_HISTORY_URL : null, fetchHistory, {
    refreshInterval: 30000,
    revalidateOnFocus: false,
  });
}
